export * from './krankheit.component';
export * from './krankheit.component.module';
